var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox } from "vue";
var _hoisted_1 = { class: "filterUI" };
var _hoisted_2 = { class: "row filterUI-body" };
var _hoisted_3 = { class: "col-4 border-end h-100" };
var _hoisted_4 = { class: "filterUI-body-left list-group list-group-flush filterUI-body-category" };
var _hoisted_5 = ["onClick"];
var _hoisted_6 = { class: "count" };
var _hoisted_7 = { class: "filterUI-body-right col h-100" };
var _hoisted_8 = { class: "row filterUI-body-list" };
var _hoisted_9 = { class: "form-check" };
var _hoisted_10 = ["id", "value", "onChange"];
var _hoisted_11 = ["for"];
var _hoisted_12 = { class: "row filterUI-footer" };
var _hoisted_13 = { class: "result d-flex flex-wrap" };
var _hoisted_14 = { class: "all" };
var _hoisted_15 = { class: "text-info mx-3" };
var _hoisted_16 = ["value"];
var _hoisted_17 = { class: "text-info mx-3" };
var _hoisted_18 = ["onClick"];
var _hoisted_19 = { key: 0 };
var _hoisted_20 = { class: "btns d-flex justify-content-end px-4 py-3" };
var _hoisted_21 = { class: "d-flex align-items-end" };
var _hoisted_22 = {
    class: "btn btn-primary text-white",
    type: "submit"
};
import { onMounted, ref } from 'vue';
import ApiService from '@/ts/core/services/ApiService';
export default /*@__PURE__*/ _defineComponent(__assign({
    name: 'recruit-etc-filter',
}, { __name: 'RecruitEtcFilter', props: {
        requestCodes: {
            required: false,
            default: [],
            type: Array
        },
        requestCategories: {
            required: false,
            default: [],
            type: Array
        },
        titles: {
            required: true,
            type: Object
        },
        locales: {
            required: true,
            type: Object
        },
        filterVisible: {
            type: Boolean,
            required: true,
        }
    }, emits: ['filter-toggle-event'], setup: function (__props, _a) {
        var _this = this;
        var __emit = _a.emit;
        var _ = require('lodash');
        var emits = __emit;
        var props = __props;
        var lang = ref(document.documentElement.lang);
        var menus = ref([
            'work_type',
            'con_visa',
        ]);
        var categories = ref([]);
        var selectedCategory = ref(null);
        var selectedCodes = ref([]);
        var displayForDyslexic = ref(true);
        onMounted(function () {
            loadCodes();
        });
        var loadCodes = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ApiService.query(process.env.MIX_API_HOST + '/service-code/', {
                            params: {
                                codes: menus.value
                            }
                        })
                            .then(function (response) {
                            var _categories = response.data.data;
                            _categories.forEach(function (category) {
                                categories.value.push(category);
                                var requestCategories = props.requestCategories;
                                var findIdx = requestCategories.findIndex(function (element) { return element.code == category.code; });
                                if (findIdx >= 0) {
                                    selectedCodes.value.push(category);
                                    displayForDyslexic.value = false;
                                }
                                var requestCodes = props.requestCodes;
                                category.children.forEach(function (child) {
                                    var findIdx = requestCodes.findIndex(function (element) { return element.code == child.code; });
                                    if (findIdx >= 0) {
                                        selectedCodes.value.push(child);
                                        displayForDyslexic.value = false;
                                    }
                                });
                            });
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        var toggleFilterPopup = function () {
            emits('filter-toggle-event');
        };
        var selectCategory = function (category) {
            selectedCategory.value = category;
        };
        var removeSelectedCode = function (code) {
            var idx = selectedCodes.value.findIndex(function (_code) { return _code.code == code.code; });
            if (idx >= 0) {
                selectedCodes.value.splice(idx, 1);
            }
        };
        var resetFilter = function () {
            selectedCodes.value = [];
            selectedCategory.value = null;
            displayForDyslexic.value = true;
        };
        var getCategory = function (category_name) {
            var findIdx = categories.value.findIndex(function (category) { return category.code == _.snakeCase(category_name); });
            return categories.value[findIdx];
        };
        var convertCategoryCode = function (category_name) {
            return _.snakeCase(category_name);
        };
        var selectCode = function (event, code) {
            var target = event.target;
            displayForDyslexic.value = false;
            if (target.checked) {
                var findIdx = selectedCodes.value.findIndex(function (_code) { return _code.code == code.parent_code; });
                if (findIdx >= 0) {
                    selectedCodes.value.splice(findIdx, 1);
                }
            }
        };
        var resetForDyslexic = function () {
            resetFilter();
            displayForDyslexic.value = true;
        };
        return function (_ctx, _cache) {
            var _a;
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary-150 text-dark position-relative",
                    onClick: _cache[0] || (_cache[0] = function ($event) { return (toggleFilterPopup()); })
                }, [
                    _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bi bi-sliders" }, null, -1)),
                    _withDirectives(_createElementVNode("span", { class: "position-absolute top-0 start-100 translate-middle badge rounded-circle filter-count-badge" }, _toDisplayString(selectedCodes.value.length), 513), [
                        [_vShow, selectedCodes.value.length > 0]
                    ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("button", {
                                    class: _normalizeClass(["list-group-item list-group-item-action", displayForDyslexic.value ? 'select' : '']),
                                    type: "button",
                                    onClick: _cache[1] || (_cache[1] = function ($event) { return (resetForDyslexic()); })
                                }, _toDisplayString(__props.locales.common_all), 3),
                                (categories.value.length > 0)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(menus.value, function (category_name) {
                                        var _a;
                                        return (_openBlock(), _createElementBlock("button", {
                                            key: category_name,
                                            class: _normalizeClass(["list-group-item list-group-item-action", { active: ((_a = selectedCategory.value) === null || _a === void 0 ? void 0 : _a.code) == convertCategoryCode(category_name) }]),
                                            type: "button",
                                            onClick: function ($event) { return (selectCategory(getCategory(category_name))); }
                                        }, [
                                            _createElementVNode("span", {
                                                class: _normalizeClass({ select: selectedCodes.value.some(function (code) { return code.code === convertCategoryCode(category_name) || code.parent_code === convertCategoryCode(category_name); }) })
                                            }, [
                                                _createTextVNode(_toDisplayString(getCategory(category_name)['lang_' + lang.value]) + " ", 1),
                                                _createElementVNode("span", _hoisted_6, _toDisplayString(getCategory(category_name).recruit_categories_count), 1)
                                            ], 2),
                                            _cache[5] || (_cache[5] = _createElementVNode("i", { class: "bi bi-chevron-right" }, null, -1))
                                        ], 10, _hoisted_5));
                                    }), 128))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _withDirectives(_createElementVNode("div", { class: "filterUI-body-list-item w-100 text-secondary-200" }, _toDisplayString(__props.locales.recruit_filter_select), 513), [
                                    [_vShow, !displayForDyslexic.value && !selectedCategory.value]
                                ]),
                                ((_a = selectedCategory.value) === null || _a === void 0 ? void 0 : _a.children)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(selectedCategory.value.children, function (code) {
                                        return (_openBlock(), _createElementBlock("div", {
                                            class: "filterUI-body-list-item",
                                            key: code.code
                                        }, [
                                            _createElementVNode("div", _hoisted_9, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    id: code.code,
                                                    type: "checkbox",
                                                    value: code,
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((selectedCodes).value = $event); }),
                                                    onChange: function ($event) { return (selectCode($event, code)); }
                                                }, null, 40, _hoisted_10), [
                                                    [_vModelCheckbox, selectedCodes.value]
                                                ]),
                                                _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: code.code
                                                }, _toDisplayString(code['lang_' + lang.value]), 9, _hoisted_11)
                                            ])
                                        ]));
                                    }), 128))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                            _withDirectives(_createElementVNode("div", _hoisted_14, [
                                _createElementVNode("span", _hoisted_15, _toDisplayString(__props.locales.common_all), 1)
                            ], 512), [
                                [_vShow, displayForDyslexic.value]
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedCodes.value, function (code) {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: 'selected_' + code.code,
                                    class: "d-flex align-items-center"
                                }, [
                                    (menus.value.indexOf(code.code) < 0)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("input", {
                                                type: "hidden",
                                                name: "etc_filter[]",
                                                value: code.code
                                            }, null, 8, _hoisted_16),
                                            _createElementVNode("span", _hoisted_17, _toDisplayString(code.parent ? code.parent['lang_' + lang.value] : '') + " > " + _toDisplayString(code['lang_' + lang.value]), 1),
                                            _createElementVNode("button", {
                                                class: "close",
                                                type: "button",
                                                "aria-label": "Close",
                                                onClick: function ($event) { return (removeSelectedCode(code)); }
                                            }, _cache[6] || (_cache[6] = [
                                                _createElementVNode("i", { class: "bi bi-x-circle-fill" }, null, -1)
                                            ]), 8, _hoisted_18)
                                        ], 64))
                                        : _createCommentVNode("", true)
                                ]));
                            }), 128)),
                            (selectedCodes.value.length == 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _cache[7] || (_cache[7] = [
                                    _createElementVNode("input", {
                                        type: "hidden",
                                        name: "etc_filter[]",
                                        value: ""
                                    }, null, -1),
                                    _createElementVNode("input", {
                                        type: "hidden",
                                        name: "etc_category_filter[]",
                                        value: ""
                                    }, null, -1)
                                ])))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("button", {
                                    class: "btn btn-sm py-0",
                                    type: "button",
                                    onClick: _cache[3] || (_cache[3] = function ($event) { return (resetFilter()); })
                                }, [
                                    _createTextVNode(_toDisplayString(__props.locales.common_reset), 1),
                                    _cache[8] || (_cache[8] = _createElementVNode("i", { class: "bi bi-arrow-counterclockwise" }, null, -1))
                                ])
                            ]),
                            _createElementVNode("button", _hoisted_22, _toDisplayString(__props.locales.common_search), 1)
                        ])
                    ])
                ], 512), [
                    [_vShow, __props.filterVisible]
                ])
            ]));
        };
    } }));
